import { render, staticRenderFns } from "./CannotPauseModal.vue?vue&type=template&id=20b50645&scoped=true&"
import script from "./CannotPauseModal.vue?vue&type=script&lang=js&"
export * from "./CannotPauseModal.vue?vue&type=script&lang=js&"
import style0 from "./CannotPauseModal.vue?vue&type=style&index=0&id=20b50645&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b50645",
  null
  
)

export default component.exports